/** Request header: the client's UI locale tag (`zh-CN`), so generated copy matches the interface. */
export const UI_LOCALE_HEADER = "x-clvabot-ui-locale";
